/**
 * Capitalizes the first letter of each word, but ONLY for a word that's entirely lowercase —
 * a word that already has any uppercase letter (an acronym like "ML"/"LLM"/"AWS", a proper noun
 * like "PostgreSQL"/"TypeScript") is left exactly as-is. Free-text LLM-extracted facet values
 * (skills, benefits, perks) come back with wildly inconsistent casing — some already correct
 * acronyms, some fully lowercase phrases like "prompting" or "debugging pipelines" — and a
 * blanket title-case pass (like normalizeJobFieldLabel's) would mangle the former by forcing the
 * rest of the word lowercase. This only fixes the genuinely-lowercase case, so a chip label never
 * looks worse than the raw value did.
 */
export function capitalizeWordsIfLowercase(value: string): string {
  if (!value) return value;
  return value
    .split(/(\s+)/)
    .map((word) => {
      if (!word.trim() || word !== word.toLowerCase()) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
}
